import sc from 'web/components/styled';
import themeClasses from 'web/styles/themeClasses.css';

const FormGroup = sc.div(themeClasses({ paddingTop: 4 }));
FormGroup.displayName = 'FormGroup';

export default FormGroup;
